"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalLambdaValues = exports.LambdaHeaderKeys = void 0;
var LambdaHeaderKeys;
(function (LambdaHeaderKeys) {
    LambdaHeaderKeys["CORRELATION_ID"] = "x-correlation-id";
    LambdaHeaderKeys["AMZ_TRACE_ID"] = "X-Amzn-Trace-Id";
    LambdaHeaderKeys["AUTHORIZATION"] = "authorization";
})(LambdaHeaderKeys = exports.LambdaHeaderKeys || (exports.LambdaHeaderKeys = {}));
let correlationId;
let userInfo;
exports.globalLambdaValues = {
    get correlationId() {
        return correlationId !== null && correlationId !== void 0 ? correlationId : "";
    },
    set correlationId(id) {
        correlationId = id;
    },
    get userInfo() {
        return userInfo !== null && userInfo !== void 0 ? userInfo : undefined;
    },
    set userInfo(user) {
        userInfo = user;
    },
    clear() {
        correlationId = undefined;
        userInfo = undefined;
    },
};
//# sourceMappingURL=header-types.js.map